import { useState } from "react"
import InputElement from "../../Common/InputElement";
import ModalElement from "../../Common/ModalElement";
import ButtonElement from "../../Common/ButtonElement";

const ReasonModal = ({show, submitAction, hideModal, title }) => {
    const [reason, setReason] = useState("");
    const [reasonErr, setReasonErr] = useState("");

    const submit = () => {
        if(!reason) setReasonErr("Please enter reason");
        else submitAction(reason);
    }

    return <ModalElement size="md" show={true} title={title} onHide={hideModal}>
        <div>
            <div className="col-12 mt-2 text-start">
                        <InputElement
                            isTextArea={true}
                            label={"Reason"}
                            placeholder={"Enter Reason"}
                            name={"reason"}
                            value={reason}
                            error={reasonErr}
                            onChange={(e) => {
                                setReasonErr(null);
                                setReason(e.target.value);
                            }}
                        />
                    </div>
            <div className="text-center my-4">
                <ButtonElement loading={false} text={"Submit"} cssClass="small-radius mb-1" onClick={submit} variant="btn-outline-primary" />
            </div>
        </div>
    </ModalElement>
}

export default ReasonModal;